<template>
    <div :class="{ 'header-technos': this.$store.state.app.page == 'technos', 'header-fv': this.$store.state.app.page == 'harkhan' }" class="header-main">
        <header>
            <div class="container">
                <div class="header">
                    <div>
                        <a href="./" :class="{ main_logo: this.$store.state.app.page == 'home' }">
                            <IconHaikara color="#FF0000" class="logo-icon" v-if="this.$store.state.app.page != 'home'" />
                            <LogoHaikara class="logo" v-if="this.$store.state.app.page == 'home'" />
                        </a>
                    </div>

                    <div>
                        <span @click="displayNav" class="menu">
                            <Menu />
                        </span>
                    </div>
                </div>
            </div>
        </header>

        <div v-show="this.$store.state.app.page == 'technos'" id="banner">
            <!--<div class="scrolldown" :class="{ hide: scrollStatus }"></div>-->
            <div ref="home-tilt" class="home-tilt">
                <img src="@/assets/img/typo_04.png" alt="" />
                <img src="@/assets/img/typo_03.png" alt="" />
                <img src="@/assets/img/typo_02.png" alt="" />
                <img src="@/assets/img/typo_01.png" alt="" />
            </div>
        </div>

        <div class="scrolldown" :class="{ hide: scrollStatus }" v-if="this.$store.state.app.page == 'technos'"></div>
    </div>
</template>

<script>
import VanillaTilt from "vanilla-tilt";
import LogoHaikara from "./img/LogoHaikara.vue";
import Menu from "./img/Menu.vue";
import IconHaikara from "./img/IconHaikara.vue";

export default {
    name: "Header",
    data() {
        return {
            scrollStatus: false,
        };
    },
    components: {
        Menu,
        LogoHaikara,
        IconHaikara,
        VanillaTilt,
    },
    mounted() {
        let video = this.$refs["video-header"];
        //if (video && video.paused) video.play();

        if (video) {
            var playPromise = video.play();

            if (playPromise !== undefined) {
                playPromise
                    .then((_) => {
                        video.play();
                    })
                    .catch((error) => {
                        console.log("error >> ", error);
                    });
            }
        }

        let homeTilt = this.$refs["home-tilt"];
        if (homeTilt) {
            VanillaTilt.init(homeTilt, {
                max: 10,
                speed: 6000,
                perspective: 1000,
            });
        }
    },
    methods: {
        displayNav: function () {
            this.$store.dispatch("app/displayNav", true);
        },
    },
};
</script>

<style scoped lang="scss">
.home-tilt {
    transform-style: preserve-3d;
    transform: perspective(2000px);
    position: absolute;

    img {
        &:first-child {
            transform: translate3d(0, 0, -25px) rotate(0deg) scale(1, 1);
        }

        &:nth-child(2) {
            transform: translate3d(0, 0, 25px) rotate(0deg) scale(1, 1);
        }

        &:nth-child(3) {
            transform: translate3d(0, 0, 50px) rotate(0deg) scale(1, 1);
        }

        &:last-child {
            transform: translate3d(0, 0, 75px) rotate(0deg) scale(1, 1);
        }
    }
}

.header-main {
    video {
        position: fixed;
        z-index: 0;
        width: 100%;
        height: 100%;
        object-fit: fill;
    }
}

.header-technos {
    height: 600px;
    display: flex;
    flex-flow: column;

    > div:not(.scrolldown) {
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        color: #ff0000;
        font-weight: 900;
        font-size: 8rem;
        flex: 1;
        position: relative;
        overflow: hidden;
        width: 100%;
    }
}

header {
    z-index: 2;
    position: fixed;
    width: 100%;
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 0;

    > div {
        height: 100px;
        position: relative;
        top: 50px;
        display: flex;
        align-items: center;

        > a {
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;

            &.main_logo {
                padding: 0 1.5rem;
                background: #fff;
                border-radius: 50px;
            }

            .logo {
                width: 170px;
            }

            .logo-icon {
                width: auto;
                height: 60px;
            }
        }
    }

    .menu {
        cursor: pointer;
        text-align: right;
        background: red;
        border-radius: 50%;
        height: 60px;
        width: 60px;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
            fill: #fff;
            height: 28px;
            width: auto;
        }
    }
}

/**
Animation banniere
*/
#banner {
    position: relative;

    > div:not(.scrolldown) {
        height: 100%;
        width: 100%;

        img {
            aspect-ratio: 384 / 179;
            //width: 100%;
            max-width: 1280px;
            max-height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            opacity: 0;
            filter: blur(4px);

            &:last-child {
                animation: fade-in 0.8s 0.1s forwards cubic-bezier(0.11, 0, 0.5, 0);
            }

            &:nth-child(3) {
                animation: fade-in 0.8s 0.9s forwards cubic-bezier(0.11, 0, 0.5, 0);
            }

            &:nth-child(2) {
                animation: fade-in 0.8s 1.7s forwards cubic-bezier(0.11, 0, 0.5, 0);
            }

            &:first-child {
                animation: fade-in 0.8s 2.5s forwards cubic-bezier(0.11, 0, 0.5, 0);
            }
        }
    }
}

/* Scroll icon */
.scrolldown {
    //position: absolute;
    width: 30px;
    height: 50px;
    border: 3px solid #ff0000;
    border-radius: 25px;
    bottom: 1rem;
    transition: all 0.5s;
    position: relative;
    margin: auto;

    &.hide {
        opacity: 0;
    }
}
.scrolldown::before {
    content: "";
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    width: 6px;
    height: 6px;
    background-color: #ff0000;
    border-radius: 100%;
    box-shadow: 0px -5px 3px 1px rgba(255, 0, 0, 0.6);
    animation: scrolldown-anim 2s infinite;
}

@keyframes scrolldown-anim {
    0% {
        opacity: 0;
        height: 6px;
    }
    40% {
        opacity: 1;
        height: 10px;
    }
    80% {
        opacity: 0;
        transform: translate(-50%, 20px);
        height: 10px;
    }
    100% {
        opacity: 0;
        height: 3px;
    }
}

.scrolldown::after {
    content: "";
    position: absolute;
    bottom: -12px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    width: 7px;
    height: 7px;
    border: 2px solid #ff0000;
    border-top: none;
    border-left: none;
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% {
        opacity: 0;
    }
    60% {
        opacity: 0.7;
    }
    100% {
        opacity: 0;
    }
}

@keyframes fade-in {
    100% {
        opacity: 1;
        filter: blur(0);
    }
}

@media (max-width: 1300px) {
    #banner {
        > div:not(.scrolldown) {
            img {
                //max-width: 100%;
            }
        }
    }
}

@media (max-width: 1200px) {
    .header-technos {
        height: auto;
        width: 100%;
        aspect-ratio: 384 / 200;
    }
}
@media (max-width: 992px) {
    .header {
        > div {
            height: 90px;
            top: 45px;

            > a {
                height: 50px;

                .logo {
                    width: 150px;
                }

                .logo-icon {
                    width: auto;
                    height: 50px;
                }
            }
        }

        .menu {
            height: 50px;
            width: 50px;

            svg {
                height: 24px;
            }
        }
    }
}

@media (max-width: 768px) {
    header {
        //position: relative;
        background-color: #fff;
    }

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;

        > div {
            height: 100%;
            top: 0;

            > a {
                height: auto;

                &.main_logo {
                    padding: 0;
                    background: transparent;
                }

                .logo {
                    width: 120px;
                }

                .logo-icon {
                    width: auto;
                    height: 24px;
                }
            }
        }

        .menu {
            height: 20px;
            width: auto;
            background: transparent;

            svg {
                height: 100%;
                fill: red;
            }
        }
    }

    .header-technos #banner {
        margin-top: 60px;
        aspect-ratio: 384 / 179;
        flex: 0 0 100%;
    }

    #banner > div:not(.scrolldown) img {
        width: 100%;
        max-height: none;
    }
}
</style>
